import { PageHeaderLayout } from "@homebound/beam";
import { BidContractsTableV2 } from "src/components/bid-contracts/BidContractsTableV2";

export function GlobalBidContractsPage() {
  return (
    <PageHeaderLayout pageHeader={{ title: "Contracts" }}>
      <BidContractsTableV2 />
    </PageHeaderLayout>
  );
}
